import axios from 'axios';
import { API_BASE_LAST_OK_KEY, API_BASE_URL, getWithFallback, postWithFallback } from '../config/api';

export interface LoginData {
  email: string;
  password: string;
}

export interface AuthResponse {
  access_token: string;
  token_type: string;
}

export interface UserData {
  id: number;
  email: string;
  full_name?: string;
  phone?: string;
  role?: string;
  is_active: boolean;
  is_verified: boolean;
  created_at: string;
}

class AuthService {
  private baseURL = `${API_BASE_URL}/api/v1/users`;

  async login(data: LoginData): Promise<AuthResponse> {
    const response = await postWithFallback<AuthResponse>('/api/v1/users/login-json', {
      email: data.email.trim().toLowerCase(),
      password: data.password,
    });
    const savedBase = localStorage.getItem(API_BASE_LAST_OK_KEY);
    if (savedBase) {
      this.baseURL = `${savedBase}/api/v1/users`;
    }
    return response;
  }

  saveToken(token: string): void {
    localStorage.setItem('token', token);
  }

  saveUserData(userData: UserData): void {
    localStorage.setItem('userEmail', userData.email);
    localStorage.setItem('userRole', userData.role || 'user');
    localStorage.setItem('userName', userData.full_name || '');
  }

  async getCurrentUser(): Promise<UserData> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }
    const data = await getWithFallback<UserData>('/api/v1/users/me', {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 15000,
    });
    const savedBase = localStorage.getItem(API_BASE_LAST_OK_KEY);
    if (savedBase) {
      this.baseURL = `${savedBase}/api/v1/users`;
    }
    return data;
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  }
}

export const authService = new AuthService();
